import { Button, DatePicker, Form, FormInstance, Space } from 'antd';
import moment from 'moment';

import { FormItemAdapter } from 'app/libs/form-item-adapter';

const requiredRules = [
  { required: true, message: 'Поле обязательно для заполнения' },
];

type RangeDateFilterFormProps = {
  form: FormInstance<{ value: { start: Date; end: Date } }>;
  value?: { start: Date; end: Date };
  onSubmit: (value: { start: Date; end: Date }) => void;
  onReset: () => void;
};
// eslint-disable-next-line mobx/missing-observer
export const RangeDateFilterForm = ({
  form,
  value,
  onSubmit,
  onReset,
}: RangeDateFilterFormProps) => {
  const handleSubmit = ({ value }: { value: { start: Date; end: Date } }) => {
    onSubmit(value);
  };

  const handleReset = () => {
    onReset();
  };

  return (
    <div className="ag-filter">
      <Form
        layout="vertical"
        className="ag-filter-wrapper ag-focus-managed"
        form={form}
        fields={[{ name: 'value', value }]}
        onFinish={handleSubmit}
        onReset={handleReset}
      >
        <div className="ag-filter-body-wrapper ag-simple-filter-body-wrapper">
          <div
            className="ag-filter-body"
            role="presentation"
            aria-hidden="false"
          >
            <div
              role="presentation"
              className="ag-labeled ag-label-align-left ag-number-field ag-input-field ag-filter-from ag-filter-filter"
              aria-hidden="false"
            >
              <div
                className="ag-wrapper ag-input-wrapper ag-number-field-input-wrapper"
                role="presentation"
              >
                <Form.Item name="value" rules={requiredRules} noStyle>
                  <FormItemAdapter
                    valueFormat={({ start, end }: any) =>
                      [moment(start), moment(end)] as any
                    }
                    onChangeFormat={([start, end]: any) => ({
                      start: start.toDate(),
                      end: end.toDate(),
                    })}
                  >
                    {(value, onChange) => (
                      <DatePicker.RangePicker
                        // prevent close popup picker on click 👇
                        popupClassName="ag-custom-component-popup"
                        format={'DD.MM.YYYY HH:mm'}
                        value={value}
                        onChange={onChange}
                        allowClear={false}
                        showTime={true}
                        style={{ width: '100%', minWidth: 300 }}
                      />
                    )}
                  </FormItemAdapter>
                </Form.Item>
              </div>
            </div>
          </div>

          <Space direction="vertical" style={{ width: '100%', marginTop: 8 }}>
            <Button type="primary" htmlType="submit" block>
              Найти
            </Button>
            <Button htmlType="reset" block>
              Сбросить
            </Button>
          </Space>
        </div>
      </Form>
    </div>
  );
};
